'use strict';

module.exports = function ($uibModal, $state, $scope, dialog, Tenant,$translate, Member, toast) {
    var _this = this;

    var loadTenants = function () {
        Tenant.statistic().$promise.then(function (data) {
            _this.Tenants = data.response;
        }).catch(function (err) {
            console.log(err);
        });
    }

    loadTenants();

    this.disableTenant = function (tenantId, status) {
        return Tenant.setTenantStatus({
            tenantId: tenantId,
            status: status
        }).$promise.then(function (data) {
            console.log(data.response);
        }).catch(function (err) {
            console.error(err);
        });
    }

    this.deleteTenant = function (tenantId) {
        $translate('DASHBOARD.DASH_ADMIN.DIAG_DEL_TENANT.BODY',{ tenantId: tenantId })
        .then(function (translatedValue) {           
            dialog.confirm({
                title:  $translate.instant('DASHBOARD.DASH_ADMIN.DIAG_DEL_TENANT.TITLE'),
                body: translatedValue,
                accept: $translate.instant('DASHBOARD.DELETE'),
                cancel: $translate.instant('DASHBOARD.CANCEL'),
                size: 'sm'
            }).then(() => {
                return Tenant.deleteById({
                    id: tenantId
                }).$promise
            }).then((data) => {
                return loadTenants();
            }).catch((error) => {
                console.error(error);
            });
        });
        
    }

    _this.openDetail = function (tenantId, tenantName) {
        var options = {
            animation: true,
            controller: require("./detail"),
            templateUrl: 'dashboard-admin/detail.html',
            controllerAs: 'ctrl',
            size: 'xlg',
            windowClass: 'dialog',
            bindToController: true,
            resolve: {
                tenantId: function () {
                    return tenantId
                },
                tenantName: function () {
                    return tenantName
                }
            }
        };
    
        $uibModal.open(options);
    };
};
